<template>
	<div>
		<Nav />
		<header>
			<div class="container relative z-10">
				<div class="pt-24 pb-20">
					<heading />
					<p
						class="block text-black dark:text-gray-800 font-light text-xl mb-10 tracking-wider"
					>
						+{{ icons.length }} Free colorful icons.
					</p>
					<a
						href="/blobs-icons.zip"
						download="blobs-icons"
						class="bg-white rounded-md px-6 py-3 font-bold btn dark:bg-gray-600 dark:text-gray-100 outline-none focus:ring ring-green-500"
					>
						Download all
					</a>
				</div>
				<search-bar
					:iconsCount="icons.length"
					v-model="query"
					@toggleDecorations="decorations = !decorations"
				/>
			</div>
		</header>

		<section class="relative z-10 -mt-20 pt-4 pb-10">
			<div class="container">
				<div class="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-4">
					<icon-card
						v-for="(icon, index) in filteredIcons"
						:key="index"
						:icon="icon"
						:decorations="decorations"
					/>
				</div>
				<p v-if="!filteredIcons.length">
					No icons, please try another search term.
				</p>
			</div>
		</section>
	</div>
</template>

<script>
import data from "../public/icons/icons.json";

import Heading from "./components/Heading.vue";
import IconCard from "./components/IconCard.vue";
import Nav from "./components/Nav.vue";
import SearchBar from "./components/SearchBar.vue";

export default {
	name: "App",
	components: { Nav, IconCard, SearchBar, Heading },
	data() {
		return {
			icons: data,
			query: "",
			decorations: false,
		};
	},
	computed: {
		filteredIcons() {
			return this.icons.filter((item) => {
				return item.includes(this.query.toLowerCase());
			});
		},
	},
};
</script>

<style lang="scss" scoped>
.container {
	@apply mx-auto px-4;

	@screen lg {
		@apply w-3/4;
	}
}

header {
	background: linear-gradient(
			90deg,
			red 0% 16.67%,
			yellow 16.67% 33.33%,
			lime 33.33% 50%,
			cyan 50% 66.67%,
			blue 66.67% 83.33%,
			magenta 83.33% 100%
		),
		conic-gradient(
			from 180deg,
			red 0%,
			yellow 0 16.67%,
			lime 0 33.33%,
			cyan 0 50%,
			blue 0 66.67%,
			magenta 0 83.33%,
			red 0 100%
		);
	background-blend-mode: screen, normal;
	@apply relative pb-20;

	&::after {
		content: "";
		@apply bg-gradient-to-b from-transparent to-gray-100 block absolute bottom-0 h-48 w-full z-0 dark:to-gray-700;
	}
}

.btn {
	@apply relative z-10 rounded;

	&::before {
		content: "";
		top: -3px;
		left: -3px;
		@apply absolute w-full h-full bg-red-500 rounded-md;
		z-index: -1;
	}
	&::after {
		content: "";
		top: 3px;
		left: 3px;
		@apply absolute w-full h-full bg-blue-500 rounded-md;
		z-index: -1;
	}
}
</style>
